/**
 * The networks supported by the crm
 */
export const networks = [
    {
        id: 1,
        name: 'YouTube'
    },
    {
        id: 2,
        name: 'Twitter'
    },
    {
        id: 5,
        name: 'Instagram'
    },
    {
        id: 3,
        name: 'Facebook'
    },
    {
        id: 4,
        name: 'Twitch'
    },
    {
        id: 6,
        name: 'Pinterest'
    },
];
/**
 * The available countries
 *
 * @type {array}
 */
export const countries = [
    'United States',
    'United Kingdom',
    'Australia',
    'Germany',
    'Italy',
    'Japan',
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Antarctic Territory',
    'British Indian Ocean Territory',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Canton and Enderbury Islands',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos [Keeling] Islands',
    'Colombia',
    'Comoros',
    'Congo - Brazzaville',
    'Congo - Kinshasa',
    'Cook Islands',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Côte d’Ivoire',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Dronning Maud Land',
    'East Germany',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'French Southern and Antarctic Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Honduras',
    'Hong Kong SAR China',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Jamaica',
    'Jersey',
    'Johnston Island',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau SAR China',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Metropolitan France',
    'Mexico',
    'Micronesia',
    'Midway Islands',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar [Burma]',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'Neutral Zone',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'North Korea',
    'North Vietnam',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pacific Islands Trust Territory',
    'Pakistan',
    'Palau',
    'Palestinian Territories',
    'Panama',
    'Panama Canal Zone',
    'Papua New Guinea',
    'Paraguay',
    "People's Democratic Republic of Yemen",
    'Peru',
    'Philippines',
    'Pitcairn Islands',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Réunion',
    'Saint Barthélemy',
    'Saint Helena',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Serbia and Montenegro',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia and the South Sandwich Islands',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'São Tomé and Príncipe',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'U.S. Minor Outlying Islands',
    'U.S. Miscellaneous Pacific Islands',
    'U.S. Virgin Islands',
    'Uganda',
    'Ukraine',
    'Union of Soviet Socialist Republics',
    'United Arab Emirates',
    'Unknown or Invalid Region',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Wake Island',
    'Wallis and Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
    'Åland Islands'
];
/**
 * Currencies
 *
 * @type {Object}
 */
export const currencies = {
    usd: {
        label: 'United States Dollar',
        symbol: '$'
    },
    aud: {
        label: 'Australian Dollar',
        symbol: 'AUD'
    },
    brl: {
        label: 'Brazilian real',
        symbol: 'BRL'
    },
    cad: {
        label: 'Canadian Dollar',
        symbol: 'CAD'
    },
    eur: {
        label: 'Euro',
        symbol: '€'
    },
    gbp: {
        label: 'Pound Sterling',
        symbol: '£'
    },
    inr: {
        label: 'Indian Rupee',
        symbol: '₹'
    },
    myr: {
        label: 'Malaysian Ringgit',
        symbol: 'RM'
    },
    sgd: {
        label: 'Singapore Dollar',
        symbol: 'SGD'
    },
    chf: {
        label: 'Swiss Franc',
        symbol: 'CHF'
    },
    nzd: {
        label: 'New Zealand Dollar',
        symbol: 'NZD'
    }
};
